import { FormikErrors } from 'formik';
import { INVALID_EMAIL_ADDRESS, REQUIRED, validateEmail } from '~/Helpers/Validators.helper';
import { ExtendedStaff } from './ExtendedSaff.model';

export const staffVerification = (data: ExtendedStaff) => {
  const errors = {} as FormikErrors<ExtendedStaff>;
  const hasRole = data?.accessType && data?.accessType > 0;
  if (!data.firstName) {
    errors.firstName = 'First name is missing';
  }

  if (!data.lastName) {
    errors.lastName = 'Last name is missing';
  }

  const emailValidationError = validateEmail(data.email);
  if (!!data.email && emailValidationError && emailValidationError === INVALID_EMAIL_ADDRESS) {
    errors.email = 'Email address is not valid';
  }
  if (
    hasRole &&
    emailValidationError &&
    (emailValidationError === REQUIRED || emailValidationError === INVALID_EMAIL_ADDRESS)
  ) {
    errors.email = 'Email address is missing or is not valid';
  }

  return errors;
};
